import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import styled from "styled-components";

export interface TextAreaProps {
  rows?: number;
  cols?: number;
  label: string;
  value: any;
  onChange?: (text: any) => void;
}

const CustomLabel = styled.div`
  font-style: italic;
  color: #484848;
  font-weight: 100;
  margin-bottom: 0.5rem;
`;

const TextArea: React.FC<TextAreaProps> = ({
  rows,
  label,
  cols,
  value,
  onChange,
}) => (
  <>
    <CustomLabel>{label}</CustomLabel>
    <InputTextarea
      style={{
        border: "1px solid  #dd052b",
        borderRadius: "10px",
        marginBottom: "1rem",
      }}
      autoResize
      rows={rows ? rows : 5}
      cols={cols ? cols : 80}
      value={value}
      onChange={(item) => onChange(item)}
    />
  </>
);

export default TextArea;
